<template>
  <v-container class="my-4">
    <div class="form p-2 mt-5">
      <v-progress-linear color="primary" value="50"/>
      <h2 class="my-5">Personal Information</h2>
      <p>We are almost there</p>
      <div class="inputs">
        <v-form>
          <v-text-field
              v-model="firstName"
              label="First Name"
              @input="$v.firstName.$touch()"
          />
          <v-text-field
              v-model="lastName"
              label="Last Name"
              @input="$v.lastName.$touch()"
          />
          <v-select
              v-model="accountType"
              :error-messages="accountTypeMessages"
              :items="accountTypes"
              :label="$t('auth.forms.labels.accountType')"
              class="accountType"
              :disabled="hasAccountType"
              data-test="accountType"
              mx-20
              prepend-inner-icon="mdi-account"
              required
              @blur="$v.accountType.$touch()"
              @input="$v.accountType.$touch()"
          />

          <v-select
              v-model="selectedCountry"
              :items="countries"
              :label="$t('profile.edit.forms.labels.country')"
              item-text="name"
              item-value="code"
              @blur="$v.selectedCountry.$touch()"
              @input="$v.selectedCountry.$touch()"

          >
            <template v-slot:item="slotProps">
              <v-avatar class="mr-3" size="20">
                <v-img :src="slotProps.item.flag"/>
              </v-avatar>
              {{ slotProps.item.name }}
            </template>
          </v-select>
          <vue-tel-input-vuetify
              v-model="phone"
              :label="$t('auth.forms.labels.phone')"
              class="px-0 py-0"
              clearable
              data-testid="phone"
              :default-country="selectedCountry"
              :error-messages="phoneErrors"
              placeholder=""
              validate-on-blur
              @validate="setPhone"
          >
          </vue-tel-input-vuetify>
          <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="birthday"
              min-width="auto"
              offset-y
              transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="birthday"
                  v-bind="attrs"
                  v-on="on"
                  label="Date of Birth"
                  readonly
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                no-title
                scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                  color="primary"
                  text
                  @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                  color="primary"
                  text
                  @click="$refs.menu.save(date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-textarea
              v-model="biography"
              label="Biography"
              rows="3"
              out-grow
          />
        </v-form>
      </div>
      <v-row>
        <v-col class="d-flex flex-row justify-space-between mt-2" cols="12">
          <v-btn
              :disabled="loading || !hasAccountType"
              class="elevetion-0"
              color="primary"
              width="20%"
              @click="handleClickSkip()"
          >Skip
          </v-btn>
          <v-btn
              :disabled="$v.$invalid || loading"
              :loading="loading"
              color="primary"
              width="45%"
              @click="handleClick()"
          >Next
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import google from "@/assets/google.png";
import Logo from "@/assets/guiomentorLogo.png";
import {minLength, required} from "vuelidate/lib/validators";
import countries from '@/constants/countries.json';
import {mapGetters, mapMutations} from 'vuex';
import axios from "axios";

export default {
  data() {
    return {
      google,
      Logo,
      loading: false,
      countries,
      menu: false,
      accountTypes: ["STUDENT", "MENTOR"],
      firstName: "",
      lastName: "",
      selectedCountry: "UG",
      phone: null,
      accountType: null,
      date: null,
      birthday: null,
      biography:'',
      phoneErrors: []
    };
  },
  async created() {
    const { data: API_COUNTRY_DATA } = await axios.get('http://ip-api.com/json');
    const { account_types: accountTypes, profile } = this.user
    this.accountType = accountTypes?.length ? accountTypes[0].name.toUpperCase() : "STUDENT"
    this.firstName = profile?.first_name|| "";
    this.biography = profile?.biography || "";
    this.lastName = profile?.last_name || "";
    this.phone = profile?.phone_number || "";
    this.selectedCountry = profile?.country || API_COUNTRY_DATA.countryCode;
    this.birthday = profile?.birthday || "";
  },
  methods: {
    ...mapMutations({
      setAuthSuccess: "auth/SET_AUTH_SUCCESS",
      setUserProfile: "auth/SET_USER_PROFILE"
    }),
    async handleClick() {
      const {firstName, lastName, selectedCountry, phone, accountType, birthday, biography} = this;
      const data = {
        firstName,
        lastName,
        selectedCountry,
        phone,
        accountType,
        biography
      }
      try {
        this.loading = true;
        await this.axios.patch(`/profile/update_profile/${this.user.id}/`, {
          country: selectedCountry,
          phone_number: phone,
          first_name: firstName,
          last_name: lastName,
          birthday,
          biography,
          account_types: [{name: accountType}]
        })
        const {data: {user}} = await this.axios.get('users/me');
        this.setAuthSuccess(user);
        this.setUserProfile(user.profile);
        this.$emit('handleClickNext', data);
        this.$snackbar.showMessage({
          content: this.$t("profile.edit.updatedSuccess"),
          color: "success"
        });
      } catch (error) {
        this.loading = false;
        this.$snackbar.showMessage({
          content: error?.response?.data?.detail || this.$t('errors.somethingWentWrongError'),
          color: "error",
        });
      }
    },
    handleClickSkip() {
      this.$emit('handleClickSkip');
    },
    setPhone({isValid, number}) {
      if (isValid) {
        this.phoneErrors = [];
        this.phone = number.e164;
      } else  {
        this.phoneErrors = [...this.phoneErrors];
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
      profile: "auth/GET_USER_PROFILE"
    }),
    hasAccountType() {
      return !!this.user?.account_types?.length
    },
    countryErrors() {
      const errors = [];
      if (!this.$v.selectedCountry.$dirty) return errors;
      !this.$v.selectedCountry.required &&
      errors.push(this.$t("profile.edit.forms.errors.country"));
      return errors;
    },
    accountTypeMessages() {
      const errors = []
      if (!this.$v.accountType.$dirty) return errors
      !this.$v.accountType.min && errors.push(this.$t('auth.forms.errors.accountType'))
      return errors
    }
  },
  validations: {
    lastName: {},
    firstName: {},
    biography: {},
    birthday: {},
    selectedCountry: {required},
    accountType: {
      required,
      min: minLength(1)
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.form {
  background: #ffffff;
  min-height: 700px;
  width: 90%;
  margin: 0 auto;
  border-radius: 20px;
  padding: 37px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .form {
    width: 100%;
  }
}

</style>
